export const SOCIAL_LINKS = [
    {
        id: 'vk',
        href: 'https://vk.ru/salon_lev',
        label: 'ВКонтакте',
    },
    {
        id: 'telegram',
        href: 'https://t.me/salonLEV',
        label: 'Телеграмм',
    },
    {
        id: 'tiktok',
        href: 'https://www.tiktok.com/@levsalonmoscow?_r=1&_t=ZS-92xgZCjAolU',
        label: 'TikTok',
    },
    {
        id: 'youtube',
        href: 'https://youtube.com/@salonl.e.v?si=dKCa4ZU696XuUuES',
        label: 'YouTube',
    },
    {
        id: 'instagram',
        href: 'https://www.instagram.com/salonlev2025/',
        label: 'Instagram',
    },
    {
        id: 'dzen',
        href: 'https://dzen.ru/id/686aa3013af4380e0b7d46e6?share_to=link',
        label: 'Дзен',
    },
];
